import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { useContext } from "react";
import FormContext from "./form.context.js";
import { prefixClassname } from "../styles/index.js";
function FormFeedback(props) {
    const { className, align: alignProp, status, ...restProps } = props;
    const { controlAlign } = useContext(FormContext);
    const align = alignProp ?? controlAlign ?? "left";
    return (React.createElement(View, { className: classNames(prefixClassname("form-feedback"), {
            [prefixClassname("form-feedback--left")]: align === "left",
            [prefixClassname("form-feedback--center")]: align === "center",
            [prefixClassname("form-feedback--right")]: align === "right",
            [prefixClassname("form-feedback--valid")]: status === "valid",
            [prefixClassname("form-feedback--warning")]: status === "warning",
            [prefixClassname("form-feedback--invalid")]: status === "invalid",
        }, className), ...restProps }));
}
FormFeedback.displayName = "FormFeedback";
export default FormFeedback;
